export const faqs = [
  {
    summary: "How do I sign up for an account?",
    detail: ` To create an account, simply visit our website and click on the
              "Sign Up" or "Get Started" button. Follow the prompts to enter
              your email address, create a password, and complete the
              registration process. Once registered, you'll have access to our
              platform and can start exploring our courses immediately.`,
  },
  {
    summary: "Can I access my courses on multiple devices?",
    detail: `Yes, you can access your courses on multiple devices such as
              laptops, desktop computers, tablets, and smartphones. Simply log
              in to your account on the device of your choice, and your progress
              and course history will sync across all devices automatically for
              seamless learning anytime, anywhere.`,
  },
  {
    summary: "Are certificates of completion provided for courses?",
    detail: ` Yes, upon successfully completing a course, you will receive a
              certificate of completion to showcase your achievement.
              Certificates can be downloaded or shared directly from your
              account. Please note that certificates are available for certain
              courses and may have specific completion criteria.`,
  },
  {
    summary: "How can I get help if I encounter any issues or have questions?",
    detail: `If you encounter any issues or have questions about our platform,
              courses, or account, our dedicated support team is here to assist
              you. You can reach out to us through the "Contact Us" page on our
              website or email us. We strive to
              provide timely and helpful assistance to ensure you have a smooth
              learning experience.`,
  },
];